import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[scheda_recupero_entity_view]',
  templateUrl: 'scheda-recupero-entity-view.component.html',
})

export class SchedaRecuperoEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element;
}
